<template>
  <div>
    <h2 v-if="company">Konfiguracja wdrożenia: {{ company.name }}</h2>
    <v-tabs v-model="tab" fixed-tabs>
      <v-tab>Rezerwacje</v-tab>
      <v-tab>Podgląd kolejek</v-tab>
      <v-tab>Szablon strony</v-tab>
      <v-tab>Dane</v-tab>
      <v-tab>Święta</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <data-table
          :headers="confHeaders"
          :items="reservationConfigs"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.value="{ item }">{{
            getValueTextFromItem(item)
          }}</template>
          <template v-slot:item.hide="{ item }">{{
            item.hide ? "Tak" : "Nie"
          }}</template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="editConfig(item)">
                  <v-icon small>fas fa-edit</v-icon>
                </v-btn>
              </template>
              Edytuj
            </v-tooltip>
          </template>
        </data-table>
      </v-tab-item>
      <v-tab-item>
        <data-table
          :headers="confHeaders"
          :items="queueConfigs"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.value="{ item }">{{
            getValueTextFromItem(item)
          }}</template>
          <template v-slot:item.hide="{ item }">{{
            item.hide ? "Tak" : "Nie"
          }}</template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="editConfig(item)">
                  <v-icon small>fas fa-edit</v-icon>
                </v-btn>
              </template>
              Edytuj
            </v-tooltip>
          </template>
        </data-table>
      </v-tab-item>
      <v-tab-item>
        <data-table
          :headers="confHeaders"
          :items="templateConfigs"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.value="{ item }">{{
            getValueTextFromItem(item)
          }}</template>
          <template v-slot:item.hide="{ item }">{{
            item.hide ? "Tak" : "Nie"
          }}</template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="editConfig(item)">
                  <v-icon small>fas fa-edit</v-icon>
                </v-btn>
              </template>
              Edytuj
            </v-tooltip>
          </template>
        </data-table>
      </v-tab-item>
      <v-tab-item>
        <data-table
          :headers="dataTemplateHeaders"
          :items="propertyTemplates"
          disable-pagination
          hide-default-footer
          sort-by="displayOrder"
        >
          <template v-slot:item.name="props">
            <v-edit-dialog
              :return-value.sync="props.item.name"
              cancel-text="Anuluj"
              large
              save-text="Zapisz"
              @save="saveEditPropertyTemplate(props.item)"
            >
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.name"
                  label="Edytuj"
                ></v-text-field>
              </template>
              {{ props.item.name }}
            </v-edit-dialog>
          </template>
          <template v-slot:item.isUniqueProperty="props">
            <v-checkbox
              v-model="props.item.isUniqueProperty"
              @click="saveEditPropertyTemplate(props.item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.isEnabled="props">
            <v-checkbox
              v-model="props.item.isEnabled"
              @click="saveEditPropertyTemplate(props.item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.actions="props">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="mr-2"
                  @click="$refs.editPropValidators.showEdit(props.item)"
                >
                  <v-icon small>fa-flag</v-icon>
                </v-btn>
              </template>
              Walidatory
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="mr-2"
                  @click="propertyTemplateSortUp(props.item)"
                >
                  <v-icon small>fa-arrow-up</v-icon>
                </v-btn>
              </template>
              Kolejność w góre
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="mr-2"
                  @click="propertyTemplateSortDown(props.item)"
                >
                  <v-icon small>fa-arrow-down</v-icon>
                </v-btn>
              </template>
              Kolejność w dół
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="deletePropertyTemplate(props.item)"
                  v-bind="attrs"
                  v-on="on"
                  class="mr-2"
                  color="error"
                >
                  <v-icon small>fa-trash</v-icon>
                </v-btn>
              </template>
              Usuń
            </v-tooltip>
          </template>
        </data-table>
      </v-tab-item>
      <v-tab-item>
        <holiday-calendar :company-id="companyId"></holiday-calendar>
      </v-tab-item>
    </v-tabs-items>
    <configuration-edit-modal ref="editConfigModal"></configuration-edit-modal>
    <edit-property-validators
      ref="editPropValidators"
    ></edit-property-validators>
  </div>
</template>

<script>
import { queueStatusDisplayMode, reservationMode, smsApiType } from "@/helpers";
import ConfigurationEditModal from "@/components/ConfigurationEditModal";
import EditPropertyValidators from "@/components/EditPropertyValidators";
import HolidayCalendar from "@/components/HolidayCalendar";

export default {
  components: {
    ConfigurationEditModal,
    EditPropertyValidators,
    HolidayCalendar
  },
  data() {
    return {
      tab: null,
      company: null,
      configurations: [],
      reservationConfigs: [],
      queueConfigs: [],
      templateConfigs: [],
      files: [],
      propertyTemplates: [],
      dataTemplateHeaders: [
        {
          text: "Nazwa",
          value: "name",
          sortable: false
        },
        {
          text: "Czy wliczany do unikatowych",
          value: "isUniqueProperty",
          sortable: false
        },
        {
          text: "Czy włączony",
          value: "isEnabled",
          sortable: false
        },
        {
          text: "Opcje",
          value: "actions",
          sortable: false
        }
      ],
      confHeaders: [
        {
          text: "Nazwa",
          value: "name"
        },
        {
          text: "Opis",
          value: "label"
        },
        {
          text: "Wartość",
          value: "value",
          width: "50%"
        },
        {
          text: "Ukryte",
          value: "hide"
        },
        {
          text: "Opcje",
          value: "actions",
          width: "10%"
        }
      ]
    };
  },
  computed: {
    companyId() {
      return parseInt(this.$route.params.companyId);
    }
  },
  methods: {
    propertyTemplateSortUp(item) {
      let upItem = this.propertyTemplates.find(
        el => el.displayOrder == item.displayOrder - 1
      );
      if (upItem) {
        upItem.displayOrder++;
        item.displayOrder--;
        this.saveEditPropertyTemplate(item);
        this.saveEditPropertyTemplate(upItem);
      }
    },
    propertyTemplateSortDown(item) {
      let downItem = this.propertyTemplates.find(
        el => el.displayOrder === item.displayOrder + 1
      );
      if (downItem) {
        downItem.displayOrder--;
        item.displayOrder++;
        this.saveEditPropertyTemplate(item);
        this.saveEditPropertyTemplate(downItem);
      }
    },
    saveEditPropertyTemplate(item) {
      this.$http.post("/Configuration/SaveEditPropertyTemplate", item);
    },
    getValueTextFromItem(item) {
      var val = "";
      if (typeof item.value == "boolean") {
        return item.value;
      }
      if (item.inputType === "SMSAPITYPE")
        return smsApiType.find(el => el.value === item.value).text;
      if (item.inputType === "QUEUESTATUSDISPLAYMODE") {
        var value = queueStatusDisplayMode.find(el => el.value === item.value);
        val = value.text ?? item.value;
      } else if (item.inputType === "RESERVATIONMODETYPE") {
        var value = reservationMode.find(el => el.value === item.value);
        val = value.text ?? item.value;
      } else {
        val = item.value;
      }
      var maxLength = 100;
      return val.length <= maxLength ? val : val.slice(0, maxLength) + "(...)";
    },
    editConfig(item) {
      this.$refs.editConfigModal.editConfig(item);
    },
    deletePropertyTemplate(item) {
      var vm = this;
      this.$http
        .delete("Configuration/RemovePropertyTemplate?id=" + item.id)
        .then(() => {
          let index = vm.propertyTemplates.indexOf(item);
          if (index >= 0) {
            vm.propertyTemplates.splice(index, 1);
          }
        });
    }
  },
  mounted() {
    var vm = this;
    vm.$http.get("Company/GetCompany?id=" + vm.companyId).then(response => {
      vm.company = response.data;
      vm.$http
        .get("Configuration/GetAllConfigurationsV3?id=" + vm.company.id)
        .then(response => {
          vm.files = response.data.files;
          vm.propertyTemplates = response.data.propertyTemplates;
          response.data.configurations.forEach(el => {
            if (el.value.toLowerCase() == "true") {
              el.value = true;
            } else if (el.value.toLowerCase() == "false") {
              el.value = false;
            }
            if (!el.label && el.name.toUpperCase() !== "ENABLEWCAG") {
              return;
            }
            switch (el.type) {
              case 0:
                vm.templateConfigs.push(el);
                break;
              case 2:
              case 1:
                vm.reservationConfigs.push(el);
                break;
              case 3:
                vm.queueConfigs.push(el);
                break;
              default:
                vm.reservationConfigs.push(el);
            }
          });
        });
    });
  }
};
</script>
